import { graphql } from "react-relay";

// components
import "@components/web-app-wrapper/WebAppWrapper.gql";

export const webAppCalendarRendererFragments = {
  viewer: graphql`
    fragment WebAppCalendarRenderer_viewer on Viewer {
      ...WebAppWrapper_viewer
      user {
        id
        flowStates(first: 1000000) {
          edges {
            node {
              ...FlowStatePoller_flowState
              id
              flowKey
              previousState
              current {
                id
                state
                percentComplete
                errorMessage
              }
              pending {
                id
                state
                percentComplete
                errorMessage
              }
            }
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              primaryOrgCalendar
              domains

              eventColoringSettingsErrorable {
                __typename

                ... on EventColoringSettings {
                  eventCategoryColorings {
                    active
                    eventCategory
                    googleColorKey
                    isUserSet
                  }
                }
              }

              flowStates(first: 1000000) {
                edges {
                  node {
                    id
                    flowKey
                    previousState
                    current {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                    pending {
                      id
                      state
                      percentComplete
                      errorMessage
                    }
                  }
                }
              }
              userTeams {
                __typename
                ... on TeamList {
                  list {
                    teamCalendarId
                    userSettings {
                      __typename
                      ... on TeamUserSettings {
                        useTeamCalendar
                      }
                    }
                    settings {
                      __typename
                      ... on TeamSettings {
                        manageTeamCalendar
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const webAppCalendarRendererQuery = graphql`
  query WebAppCalendarRendererQuery {
    viewer {
      ...WebAppCalendarRenderer_viewer
    }
  }
`;
